<div *ngIf="alertO?.isLoader">

    <div class="spinner" id="spinner">
        <div class="rect1"></div>
        <div class="rect2"></div>
        <div class="rect3"></div>
        <div class="rect4"></div>
        <div class="rect5"></div>
    </div>
<!-- 
  <h2 class="wait-guest text-center mt-2 mb-0">Please wait for host to start the session.</h2> -->
</div>
<div class="popup-info-image text-center" [ngStyle]="{'max-width': alertO.isWarn ? 'inherit' : ''}" *ngIf="alertO.image">
  <img *ngIf="!alertO.isSvgString" src="{{'assets/images/' + alertO.image}}" alt="">
  <div class="linkedin-icon" *ngIf="alertO.isSvgString" [innerHTML]="alertO.image | domSanitize"> </div>
</div>
<h2 mat-dialog-title class="text-center">{{alertO?.title}}</h2>
<button mat-button class="close" mat-dialog-close (click)="closeDailog(false)" *ngIf="!alertO.isRejectBtn && !alertO.hideClose">
  <span class="material-icons">
    close
  </span>
  Close
</button>
<div mat-dialog-content>
  <p class="mt-0 text-center" *ngIf="!alertO.isHtml">
    {{alertO?.description}}
  </p>
  <p class="mt-0 text-center" *ngIf="alertO.isHtml" [innerHtml]='alertO?.description'></p>

  <div class="text-center">
    <button mat-flat-button class="button button-medium outline" type="submit" (click)="closeDailog(true)"
      *ngIf="alertO?.isConfirmBox">
      {{alertO?.btnCaption}}</button>

    <button mat-flat-button class="button button-medium button-two filled" type="submit" (click)="closeDailog(false)"
      *ngIf="alertO.isRejectBtn">
      {{alertO?.rejectBtnCaption}}</button>
  </div>
</div>

<div class="text-center dont-warn" *ngIf="alertO?.isConfirmBox">
  <mat-checkbox *ngIf="alertO?.isRemember" (change)="dontWarn()">Don't warn me again</mat-checkbox>
</div>